import Button from "../../../../../../common/components/atom/Button/Button";
import SelectInput from "../../../../../../common/components/atom/SelectInput/SelectInput";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import { UserRole } from "../../../../../user/types/user.types";
import {
  ConnectorDataForm,
  ConnectorDataFormErrorState,
} from "../AddNewConnectorFormPresenter";
import styles from "./AddNewConnectorFormView.module.scss";
export interface NewConnectorFormProps {
  formData?: ConnectorDataForm;
  setFormData: (key: keyof ConnectorDataForm, value: string) => void;
  errorStatus?: ConnectorDataFormErrorState;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
  isUpdate?: boolean;
}

export default function AddNewConnectorFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Ajouter",
  description = "Saisissez les informations du nouveau connecteur",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
}: NewConnectorFormProps) {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Tag"
              value={formData?.tagId}
              error={errorStatus?.isErrorTagId}
              onChange={(e) => {
                setFormData("tagId", e.target.value);
              }}
              type="number"
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label="Type"
              value={formData?.type}
              error={errorStatus?.isErrorType}
              handleChange={(value) => {
                setFormData("type", value as string);
              }}
              options={[
                { value: "Type2", label: "Type2" },
                { value: "CCS2", label: "CCS2" },
                { value: "GB/T", label: "GB/T" },
                { value: "E/F", label: "Prise Domestique EF" },
              ]}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Puissance max (kW)"
              value={formData?.maxPowerKW}
              error={errorStatus?.isErrorMaxPowerKW}
              onChange={(e) => {
                setFormData("maxPowerKW", e.target.value);
              }}
              type="number"
            />
          </div>

          <h2 className={[styles["form__intersection-name"]].join(" ")}>
            Prix par kWh
          </h2>

          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label="Devise"
              value={formData?.type}
              error={errorStatus?.isErrorCurrency}
              handleChange={(value) => {
                setFormData("currency", value as string);
              }}
              options={[{ value: "FCFA", label: "FCFA" }]}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={
                "Prix" +
                (formData?.currency ? " (en " + formData.currency + ")" : "")
              }
              value={formData?.pricePerKwh}
              error={errorStatus?.isErrorPricePerKwh}
              onChange={(e) => {
                setFormData("pricePerKwh", e.target.value);
              }}
              type="number"
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
